import { Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import Loading from "components/common/loading/Loading";
import { showErrorToast } from "utils/toast";
import BIllableIntervalChart from "./chart/BIllableIntervalChart";

import { useGetBillableIntervalAnalyticQuery } from "app/store/dashboard/billable_interval_analytic/api/billableIntervalAnalyticApi";
import BillableIntervalAnalyticIntervalFilter from "./filters/BillableIntervalAnalyticIntervalFilter";
import BillableIntervalAnalyticAccountFilter from "./filters/BillableIntervalAnalyticAccountFilter";
import BillableIntervalAnalyticDateFilter from "./filters/BillableIntervalAnalyticDateFilter";

const BillableIntervalAnalytic = () => {
  const { accountFilter, startDate, endDate, interval } = useSelector(
    (state) => state.billableIntervalAnalytic
  );
  const { data, isLoading, isFetching, isError, error } =
    useGetBillableIntervalAnalyticQuery(
      { account: accountFilter, startDate, endDate, interval },
      {
        refetchOnMountOrArgChange: true,
      }
    );

  useEffect(() => {
    if (isError && error?.message) {
      showErrorToast(error?.message);
    }
  }, [isError]);

  return (
    <Card
      elevation={0}
      style={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          flex={1}
          alignItems="center"
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
          spacing={1}
        >
          <Grid item>
            <Typography
              variant="h6"
              style={{ fontSize: "1.125rem", fontWeight: 500 }}
            >
              Billable Interval Transmissions
            </Typography>
          </Grid>
          <Grid item>
            <Grid container alignItems="center" spacing={1.5}>
              <BillableIntervalAnalyticAccountFilter />
              <BillableIntervalAnalyticDateFilter />
              <BillableIntervalAnalyticIntervalFilter />
            </Grid>
          </Grid>
        </Grid>
        {isLoading || isFetching ? (
          <Loading height="300px" />
        ) : (
          <Grid container flex flexDirection={"column"}>
            <BIllableIntervalChart data={data} />
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default BillableIntervalAnalytic;
